import { useEffect } from 'react';
import { ModalProps } from '../../../../../../components/modal/modal';
import { useLang } from '../../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../../hooks/use-query-params';
import { TasksPath } from '../../../../../../routes/manager/manager-enums';
import { TaskStatusType, TaskTypeType } from '../../../../../../store/api/tasks-api';
import { useEmployeesStore } from '../../../../../../store/use-employee-store';
import { useSchedulerStore } from '../../../../../../store/use-scheduler-store';
import { useTaskStore } from '../../../../../../store/use-task-store';

const processTaskStatuses: TaskStatusType[] = [
  'RESERVED',
  'PROGRESS',
  'READY_FOR_PICKUP',
  'SENT_TO_KITCHEN',
  'RESERVED_BY_ANOTHER_STAFF',
];

const taskTypePath: Record<TaskTypeType, TasksPath> = {
  ORDER: TasksPath.Order,
  ACTION: TasksPath.Action,
  COMMON: TasksPath.Common,
};

export const useDeleteEmployeeModal = (props: ModalProps) => {
  const { isLoading, staff, deleteEmployee } = useEmployeesStore();
  const { fetchTaskList, isLoadingFetch, list: taskList } = useTaskStore();
  const { fetchList, list: schedulerList } = useSchedulerStore();
  const { getQueryParams } = useQueryParams();
  const params = getQueryParams();
  const id = params.id;
  const { t, getLocale } = useLang();

  const employee = staff?.find((item) => String(item.id) === id);
  const employeeActiveTasks = taskList?.filter((item) => processTaskStatuses.includes(item.status));
  const employeeName = `${getLocale(employee?.surname)} ${getLocale(employee?.name)}`;

  const type = taskList?.find((item) => taskTypePath[item.type]);
  const path = type ? taskTypePath[type.type] : undefined;

  useEffect(() => {
    if (employee) {
      const params = {
        employee: employeeName,
        since_id: 0,
        is_by_company: true,
        n: 1000,
      };

      fetchTaskList(params);
      fetchList(params);
    }
  }, [employee?.id, employeeName]);

  const handleConfirm = async () => {
    try {
      await deleteEmployee(id);
      props.onClose();
    } catch (e) {
      console.error(e);
    }
  };

  return {
    isLoading,
    isLoadingFetch,
    t,
    handleConfirm,
    employeeActiveTasks,
    schedulerList,
    employee,
    employeeName,
    path,
  };
};
